function handleImage(image) {
    if (image.classList.contains('loaded')) return; // Prevent duplicate execution

    if (image.complete && image.naturalHeight !== 0) {
        requestAnimationFrame(() => {
            image.classList.add('loaded');
        });
    } else {
        image.addEventListener('load', () => {
            image.classList.add('loaded');
        }, { once: true }); // Ensures it only fires once
    }
}

function initImages() {
    const images = document.querySelectorAll('.custom-responsive-image:not(.loaded)');
    
    if (images.length === 0) {
        setTimeout(initImages, 100); // Retry in 100ms if no images found
        return;
    }

    images.forEach(handleImage);
}

// Function to continuously check for images that still don't have "loaded"
function checkForMissedImages() {
    document.querySelectorAll('.custom-responsive-image:not(.loaded)').forEach(handleImage);
}

// Run immediately (doesn't wait for DOMContentLoaded)
initImages();

// Keep checking every second for missed images
setInterval(checkForMissedImages, 1000);

// Watch for dynamically added images
const observer = new MutationObserver(() => {
    checkForMissedImages();
});

observer.observe(document.body, { childList: true, subtree: true });
